import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { IngredientCreateStockPage } from '../../ingredient-create/ingredient-create-stock/ingredient-create-stock';
import { ProviderOrderAddPage } from '../../../providers/orders/provider-order-add/provider-order-add';
import { IngredientAddStockPage } from '../../ingredient-create/ingredient-add-stock/ingredient-add-stock';
import { StockElementPage } from '../../../analytics/reports/stock-element/stock-element';

/**
 * Generated class for the IngredientViewTagsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ingredient-view-stock',
    templateUrl: 'ingredient-view-stock.html',
})
export class IngredientViewStockPage {
    @Input() ingredient: any;
    tags: any = [];

    constructor(public navCtrl: NavController,
        public navParams: NavParams) {
    }

    edit() {
        this.navCtrl.push(IngredientCreateStockPage, {
            update_state: true,
            ingredient_uid: this.ingredient.UID,
            ingredient_name: this.ingredient.name,
            measurement: this.ingredient.measurement,
            stock: this.ingredient.stock,
            stock_alert: this.ingredient.stock_alert,
            stock_max: this.ingredient.stock_max,
            reference: this.ingredient.reference
        });
    }

    add() {
        this.navCtrl.push(IngredientAddStockPage, {
            update_state: true,
            ingredient_uid: this.ingredient.UID,
            ingredient_name: this.ingredient.name,
            measurement: this.ingredient.measurement,
            stock: this.ingredient.stock,
            stock_alert: this.ingredient.stock_alert,
            stock_max: this.ingredient.stock_max,
            reference: this.ingredient.reference
        });
    }

    openProviderOrderAdd(element) {
        this.navCtrl.push(ProviderOrderAddPage, {
            element: element,
            type: 'ingredient'
        });
    }

    openElementStockAnalytics(ingredient) {
        this.navCtrl.push(StockElementPage, {
            element: ingredient
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-view/ingredient-view-stock/ingredient-view-stock.ts